import { render, staticRenderFns } from "./OrganizationUnavailable.vue?vue&type=template&id=165010ec&scoped=true"
import script from "./OrganizationUnavailable.vue?vue&type=script&lang=js"
export * from "./OrganizationUnavailable.vue?vue&type=script&lang=js"
import style0 from "./OrganizationUnavailable.vue?vue&type=style&index=0&id=165010ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165010ec",
  null
  
)

export default component.exports